module.exports = __webpack_public_path__ + "static/media/Challenger_Sweepers.74185558.jpg";